import React, { Component } from 'react';
import './modal.scss';

class Modal extends Component {
    handleCloseModal = (e) => {
        e.preventDefault();
        this.props.handleRemoveModal();
    };

    render() {
        return (
            <div>
                <div className="modal-outer-wrapper">
                    <div className="modal-background" onClick={this.handleCloseModal}></div>
                    <div className="modal-content-wrapper">{this.props.children}</div>
                </div>
            </div>
        )
    }
}

export { Modal };